// 在http.js中引入axios
import Vue from 'vue'
import axios from 'axios';
import {
	Notify
} from 'vant';
import router from '@/router/index.js'
import store from '@/store'
Vue.use(Notify)
const apiUrl = "/api"
// console.log(process.env)
if (process.env.NODE_ENV === 'development') {
	// axios.defaults.baseURL = 'http://kf.xty86.com/jeecg-boot/';
	axios.defaults.baseURL = "/api";
}  else {
	axios.defaults.baseURL = "/jeecg-boot";
	// axios.defaults.baseURL = 'http://kf.xty86.com/jeecg-boot/';
	// axios.defaults.baseURL = 'http://kf.xty86.com/jeecg-boot/';
}

// 请求超时时间
axios.defaults.timeout = 10000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//请求拦截器
axios.interceptors.request.use(
	config => {
		// 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
		// 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
		const token = store.getters.sToken;
		token && (config.headers.common['token'] = token);
		return config;
	},
	error => {
		return Promise.error(error);
	})

// todo 响应拦截器
axios.interceptors.response.use(
	response => {
		if (response.status === 200) {
			// console.log(response.data.retCode === '0000')
			if(response.data.code === 200 || response.data.retCode === '0000'){
				// console.log('chengg')
				let now = new Date().getTime();
				store.commit('sSetTokenTime',now)
				return Promise.resolve(response);
			}else if(response.data.code === 401 || response.data.code === 403){
				let now = new Date().getTime();
				let timeDiff = now - store.getters.tokenTime;
				if(timeDiff<30 * 60 * 1000){
					Notify('登陆超时');
				}
				store.commit('sSetToken','')
				router.push({name:'login'});
				return Promise.reject(response);
			}else{
				let now = new Date().getTime();
				store.commit('sSetTokenTime',now)
				Notify(response.data.message);
				return Promise.reject(response);
			}
			
		}else {
			return Promise.reject(response);
		}
	},
	// 服务器状态码不是200的情况    
	error => {
		if (process.env.NODE_ENV == 'development') {
			Notify('网络超时');
		}
		return Promise.reject(error.response);
	}
)
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			})
			.then(res => {
				if (res.data.code === 200 || res.data.retCode === '0000') {
					resolve(res.data.result?res.data.result:res.data);
				} else {
					Notify(res.data.message);
				}

			})
			.catch(err => {
				reject(err)
			})
	});
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				if (res.data.code === 200 || res.data.retCode === '0000') {
					resolve(res.data.result?res.data.result:res.data);
				} else {
					Notify(res.data.message);
				}
			})
			.catch(err => {
				reject(err)
			})
	});
}


export function postParams(url, params) {
	console.log(url,params)
	return new Promise((resolve, reject) => {
		axios.post({
			url:url,
			params:params
		})
			.then(res => {
				console.log(res)
				if (res.data.code === 200 || res.data.retCode === '0000') {
					resolve(res.data.result?res.data.result:res.data);
				} else {
					Notify(res.data.message);
				}
			})
			.catch(err => {
				reject(err)
			})
	});
}
/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deleteFn(url, params) {
	return new Promise((resolve, reject) => {
		axios.delete(url, {
				params
			})
			.then(res => {
				if (res.data.code === 200 || res.data.retCode === '0000') {
					resolve(res.data.result);
				} else {
					Notify(res.data.message);
				}
			}, err => {
				reject(err)
			})
	})
}
/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
	return new Promise((resolve, reject) => {
		axios.put(url, params)
			.then(res => {
				if (res.data.code === 200 || res.data.retCode === '0000') {
					resolve(res.data.result);
				} else {
					Notify(res.data.message);
				}
			}, err => {
				reject(err)
			})
	})
}
/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deleteBody(url, params) {
	return new Promise((resolve, reject) => {
		axios.delete(url, {
				data: params
			})
			.then(res => {
				if (res.data.code === 200 || res.data.retCode === '0000') {
					resolve(res.data.result);
				} else {
					Notify(res.data.message);
				}
			}, err => {
				reject(err)
			})
	})
}

export const axios_ = axios
